// Geo helpers for corridor/route matching. Geometry is stored as [[lat,lng], ...].

function pointSegKm(plat, plng, alat, alng, blat, blng) {
  const latr = (((alat + blat) / 2) * Math.PI) / 180;
  const kx = 111.32 * Math.cos(latr);
  const ky = 110.574;
  const ax = alng * kx, ay = alat * ky;
  const bx = blng * kx, by = blat * ky;
  const px = plng * kx, py = plat * ky;
  const dx = bx - ax, dy = by - ay;
  const seg2 = dx * dx + dy * dy;
  if (seg2 === 0) return Math.hypot(px - ax, py - ay);
  let t = ((px - ax) * dx + (py - ay) * dy) / seg2;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
}

export function pointNearPolyline(lat, lng, geometry, bufferKm = 8) {
  if (lat == null || lng == null || !geometry || !geometry.length) return false;
  if (geometry.length === 1) {
    const g = geometry[0];
    return pointSegKm(lat, lng, g[0], g[1], g[0], g[1]) <= bufferKm;
  }
  for (let i = 0; i < geometry.length - 1; i++) {
    const a = geometry[i], b = geometry[i + 1];
    if (!a || !b || a.length < 2 || b.length < 2) continue;
    if (pointSegKm(lat, lng, a[0], a[1], b[0], b[1]) <= bufferKm) return true;
  }
  return false;
}

// True if a road alert belongs to a route: on one of its highways AND, for
// geo-fenced routes, near the drive geometry. Legacy routes (no geometry)
// fall back to highway-only matching.
export function alertOnRoute(alert, route) {
  const keys = route.highway_keys || route.keys || [];
  const geom = route.geometry;
  if (alert.highway_key) {
    if (!keys.includes(alert.highway_key)) return false;
    if (geom && geom.length && alert.lat != null && alert.lng != null) {
      return pointNearPolyline(alert.lat, alert.lng, geom, route.buffer_km || 8);
    }
    return true;
  }
  // Local-council event (e.g. Auckland Transport) — no highway key; geo-fence only.
  if (geom && geom.length && alert.lat != null && alert.lng != null) {
    return pointNearPolyline(alert.lat, alert.lng, geom, route.buffer_km || 8);
  }
  return false;
}
